import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
var templateActionsWorker = {
  init: function init() {
    this.initForms();
    var isUserAuthorized = !!common.config.user.id;
    var $accountPickerModal = this.initAccountPickerModal();
    $('.js__create-example-template').on('click', function (e) {
      e.preventDefault();
      var $btn = $(this);
      $btn.addClass('loading');

      if (isUserAuthorized) {
        return templateActionsWorker.runAuthorizedCopyFlow($btn, $accountPickerModal);
      }

      return templateActionsWorker.runUnauthorizedCopyFlow($btn);
    });
  },
  initForms: function initForms() {
    var $forms = $('.js__create-template-form');
    $forms.each(function () {
      var $this = $(this),
          $input = $this.find('.js__create-template-input'),
          $button = $this.find('.js__create-example-template');
      $input.keyup(function (e) {
        if (e.keyCode === 13) {
          $button.trigger('click');
        }
      });
    });
  },
  doCopy: function doCopy($btn, copyBoardAccountId, workspaceKey) {
    var strUtm = $btn.data('utm') || '',
        place = $btn.data('place') || '',
        btnText = $btn.data('text') || this.innerText || '',
        $parent = $btn.parents('.js__create-template-form'),
        $input = $parent.find('.js__create-template-input'),
        href = $btn.attr('href'),
        templateId = $btn.data('template-id'),
        templateName = $btn.data('template-name');
    common.cookie.set('copyBoardId', templateId);

    if (copyBoardAccountId) {
      common.cookie.set('copyBoardAccountId', copyBoardAccountId);
    }

    if (typeof analytics !== 'undefined') {
      analytics.track('start_with_template', {
        example_name: templateName,
        example_id: templateId,
        button_place: place,
        button_text: btnText
      });
    }

    if (window.dataLayer && place.length > 0) {
      dataLayer.push({
        event: 'ga-event',
        hitType: 'event',
        eventCategory: 'start_with_template',
        eventAction: place,
        eventLabel: btnText
      });
    }

    setTimeout(function () {
      if ($parent.length) {
        if ($input.val()) {
          window.location = href + '?email=' + $input.val();
        } else {
          window.location = href;
        }
      } else {
        if ($btn.hasClass('is-direct-button')) {
          window.location = href;
        } else {
          /* Если не авторизованы */
          if (!common.config.user.id) {
            if (common.cookie.get('isRegistered')) {
              common.redirect('/login/' + strUtm);
            } else {
              common.redirect('/signup/' + strUtm);
            }
          }

          common.redirect(workspaceKey ? '/s/' + workspaceKey + '/app/' : '/app/');
        }
      }

      $btn.removeClass('loading');
    }, 300);
  },
  runUnauthorizedCopyFlow: function runUnauthorizedCopyFlow($btn) {
    return templateActionsWorker.doCopy($btn);
  },
  runAuthorizedCopyFlow: function runAuthorizedCopyFlow($btn, $accountPickerModal) {
    if (analytics) {
      analytics.track('start_with_template', {
        example_name: $btn.data('template-name'),
        example_id: $btn.data('template-id'),
        button_place: $btn.data('place'),
        button_text: $btn.text().trim()
      });
    }

    if (dataLayer) {
      dataLayer.push({
        event: 'ga-event',
        hitType: 'event',
        eventCategory: 'start_with_template',
        eventAction: $btn.data('place'),
        eventLabel: $btn.text().trim()
      });
    }

    function copyBoardToAccount(accountId, workspaceKey) {
      return templateActionsWorker.doCopy($btn, accountId, workspaceKey);
    }

    function onAccountPickerLoaded(accountsIds, workspaceKey) {
      if (accountsIds.length > 1) {
        $btn.removeClass('loading');
      } else {
        // if user has only one account
        return templateActionsWorker.doCopy($btn, accountsIds[0], workspaceKey);
      }
    }

    return this.initAccountPicker($accountPickerModal, copyBoardToAccount, onAccountPickerLoaded);
  },
  initAccountPickerModal: function initAccountPickerModal() {
    var $accountPickerModal = $('<div class="account-picker-modal"></div>');
    $('body').append($accountPickerModal);
    return $accountPickerModal;
  },
  initAccountPicker: function initAccountPicker($modal, copyBoardToAccount, onLoaded) {
    var $accountPicker = $('<iframe id="account-picker" name="account-picker" src="' + window.location.origin + '/app/account-picker/?filterCanCreateBoard=1"></iframe>');

    function onPickerLoad(accountsIds, workspaceKey) {
      if (accountsIds.length > 1) {
        $modal.addClass('account-picker-modal--visible');

        if (typeof analytics !== 'undefined') {
          analytics.track('account_picker_shown', {
            opened_from: 'site'
          });
        }
      }

      return onLoaded(accountsIds, workspaceKey);
    }

    function onPickerClose() {
      $modal.removeClass('account-picker-modal--visible');
      templateActionsWorker.accountPickerMessagesListener.destroy();
      $modal.html('');
    }

    function onPickerSubmit(accountId, workspaceKey) {
      copyBoardToAccount(accountId, workspaceKey);
      onPickerClose();
    }

    templateActionsWorker.accountPickerMessagesListener.run(onPickerLoad, onPickerClose, onPickerSubmit);
    $modal.append($accountPicker);
  },
  accountPickerMessagesListener: {
    listener: null,
    createListener: function createListener(onLoad, onCancel, onSubmit) {
      return function (msg) {
        try {
          var data = JSON.parse(msg.data);

          if (!data.type) {
            return;
          }

          switch (data.type) {
            case 'account-picker/loaded':
              if (typeof onLoad === 'function') {
                onLoad(data.payload.accountsIds, data.payload.workspaceKey);
              }

              break;

            case 'account-picker/submit':
              if (typeof onSubmit === 'function') {
                if (typeof analytics !== 'undefined') {
                  analytics.track('account_selected_in_account_picker', {
                    chosen_account_id: data.payload.accountId,
                    accounts_list_index: data.payload.accountsListIndex
                  });
                }

                onSubmit(data.payload.accountId, data.payload.workspaceKey);
              }

              break;

            case 'account-picker/cancel':
              if (typeof onCancel === 'function') {
                onCancel();
              }

              break;

            default:
              break;
          }
        } catch (e) {// just catch invalid events, nothing to do
        }
      };
    },
    run: function run(onLoad, onCancel, onSubmit) {
      if (!this.listener) {
        this.listener = this.createListener(onLoad, onCancel, onSubmit);
      }

      window.addEventListener('message', this.listener);
    },
    destroy: function destroy() {
      window.removeEventListener('message', this.listener);
      this.listener = null;
    }
  }
};
export default {
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var common, jQuery;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import('./common.legacy');

            case 2:
              common = _context.sent;
              common["default"].init();
              _context.next = 6;
              return import('jquery');

            case 6:
              jQuery = _context.sent;
              window.$ = window.jQuery = jQuery["default"];
              templateActionsWorker.init();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function init() {
      return _init.apply(this, arguments);
    }

    return init;
  }()
};